import { createStyles } from 'antd-style';

import { ThemeSpaces } from '../theme';
import { header } from '../styles/mixins';

export const useNonLoggedHeaderStyles = createStyles(({ token }) => ({
  nonLoggedHeader: {
    ...header({
      token,
      breakLg: token.screenXLMin,
      breakSm: token.screenMDMin,
    }),

    [`@media (max-width: ${token.screenXSMax}px)`]: {
      margin: -ThemeSpaces.SPACE_NORM,
      marginBottom: 0,
    },

    '&, & .ant-form-item-label > label': {
      color: token.colorPrimary,
      fontWeight: 'bold',
    },

    '& .ant-form-item-label > label': {
      height: 30,
    },
  },
  nonLoggedMenu: {
    '&.LinksRow': {
      color: token.colorPrimary,
      fontWeight: 'bold',
      [`@media (min-width: ${token.screenXLMin}px)`]: {
        fontSize: token.fontSize,
      },
      [`@media (max-width: ${token.screenLGMax}px)`]: {
        fontSize: token.fontSizeSM,
      },
    },
  },
}));
